import {
  Context,
  IActions,
  ICurrencyActions, ICustomerActions,
  IInfoActions, IModalActions, IPaymentActions, IPromoCodeActions, IRequestActions,
  IServiceActions,
  ITravelActions
} from './index'
import {
  ICurrencyData,
  IPricePayload,
  IListResponse,
  ServiceType,
  Travel,
  ITravelFilterDataExtended,
  Partner,
  ContactWay,
  IContactRequestPostData,
  ContactRequest,
  FaqItem,
  ICriterion,
  IAccommodation,
  ITaste,
  ILocation,
  IType,
  Accommodation,
  Type,
  Taste,
  Location,
  ISeason,
  Season,
  IRequestExtended,
  ITravelLimits,
  ITravel,
  ITravelData,
  IPartner,
  IRequestService,
  IContactRequest,
  IServiceType,
  IContactWay,
  IFaqItem,
  ISolution,
  Solution,
  ITravelFilterData,
  IServiceTypeFilterData,
  IServiceTypePriceReverse,
  ServiceTypePriceReverse,
  IModalInitData,
  IServiceOrderData,
  IAddOrderResponseData,
  IOrder,
  Order,
  ITravelInfoIdsExtendedData,
  IRequestServicePostData,
  Contact,
  IContact,
  IOrderData,
  ICheckout,
  ICheckoutResponse,
  IOrderHistory,
  OrderHistory,
  IRequestServiceHistory,
  RequestServiceHistory,
  IPublicPlanOrderData,
  IRequestTravelHistory,
  RequestTravelHistory,
  IPlanOrderData,
  ISolutionOrderData,
  ISolutionFilterData,
  IPromoCode,
  PromoCode,
  ICertItemFilterData,
  IPromoCodeOrderData,
  IRequestPromoCodeHistory,
  RequestPromoCodeHistory,
  IAppendServiceData, RequestService, IOrderUpdateStatus, INewsData, IBeautyPlaceData, BeautyPlace, News, INews, IBeautyPlace} from '../../entities'
import {
  AxiosResponse
} from "axios";
import {
  Theme
} from '../index'
import i18n from '../../i18n'
import {camelCase} from '@/filters'
import cookie from '@/cookie'


const currencyActions: ICurrencyActions = {
  fetchCurrencies(): void {
    this.$services.currency.getAll(i18n.locale)
      .then((res: AxiosResponse<IListResponse<ICurrencyData[]>>) => {
        this.$storage.mutations.fetchCurrencies(res.data.results)
        this.$storage.actions.setCurrency(res.data.results[0])
      })
      .catch(() => {
        // console.error(reason.detail)
      })
  },
  setCurrency(context: Context, payload: ICurrencyData): void {
    this.$storage.mutations.setCurrency(payload)
  },
  getPrice(context: Context, payload: IPricePayload): Promise<number> {
    return new Promise<number>((resolve, reject) => {
      this.$services.currency.getPrice(payload, i18n.locale)
        .then((res: AxiosResponse<IListResponse<number>>) => {
          resolve(res.data.results)
        })
        .catch((reason: any) => {
          reject(reason)
        })
    })
  }
}

const serviceActions: IServiceActions = {
  fetchServiceTypes(context: Context, payload?: IServiceTypeFilterData): Promise<IServiceType[]> {
    return new Promise<IServiceType[]>((resolve, reject) => {
      this.$services.service.getAllTypes(payload, i18n.locale)
        .then(res => {
          resolve(
            res.data.results?.map(serviceType => new ServiceType(serviceType))
          )
        })
        .catch(reject);
    });
  },
  getServiceTypeById(context: Context, payload: number): Promise<IServiceType | undefined> {
    return new Promise<IServiceType | undefined>((resolve, reject) => {
      this.$services.service.getTypeById(payload, i18n.locale)
        .then(res => {
          let item = res.data;
          resolve(item ? new ServiceType(item) : undefined)
        })
        .catch(reject);
    });
  },

  fetchServiceTypePrices(context: Context, payload?: IServiceTypeFilterData): Promise<IServiceTypePriceReverse[]> {
    return new Promise<IServiceTypePriceReverse[]>((resolve, reject) => {
      this.$services.service.getAllTypePrices(payload, i18n.locale)
        .then(res => {
          resolve(
            res.data.results?.map(price => new ServiceTypePriceReverse(price))
          )
        })
        .catch(reject);
    });
  },
  getServiceTypePriceById(context: Context, payload: number): Promise<IServiceTypePriceReverse | undefined> {
    return new Promise<IServiceTypePriceReverse | undefined>((resolve, reject) => {
      this.$services.service.getTypePriceById(payload, i18n.locale)
        .then(res => {
          let item = res.data;
          resolve(item ? new ServiceTypePriceReverse(item) : undefined)
        })
        .catch(reject);
    });
  },

  fetchSolutions(context: Context, payload?: ISolutionFilterData): Promise<ISolution[]> {
    return new Promise<ISolution[]>((resolve, reject) => {
      this.$services.service.getAllSolutions(payload, i18n.locale)
        .then(res => {
          resolve(
            res.data.results?.map(solution => new Solution(solution))
          )
        })
        .catch(reject);
    });
  },
  getSolutionById(context: Context, payload: number): Promise<ISolution | undefined> {
    return new Promise<ISolution|undefined>((resolve, reject) => {
      this.$services.service.getSolutionById(payload, i18n.locale)
        .then(res => {
          let item = res.data;
          resolve(item ? new Solution(item) : undefined)
        })
        .catch(reject);
    });
  },
  setRequestServiceContact(context: Context, payload: IRequestExtended<IRequestServicePostData>): Promise<IContact> {
    return new Promise<IContact>((resolve, reject) => {
      this.$services.service.setRequestServiceContact(payload, i18n.locale)
        .then(res => {
          resolve(new Contact(res.data))
        })
        .catch(reject);
    })
  },
  getRequestServiceHistories(context: Context, payload: IRequestExtended): Promise<IRequestServiceHistory[]> {
    return new Promise<IRequestServiceHistory[]>((resolve, reject) => {
      this.$services.service.getRequestServiceHistories(payload)
        .then(res => {
          resolve(res.data.results?.map(history => new RequestServiceHistory(history)))
        })
        .catch(reject);
    })
  }
}

const travelActions: ITravelActions = {
  fetchTravels(context: Context, payload?: IRequestExtended<ITravelFilterDataExtended>): Promise<IListResponse<ITravel[]>> {
    return new Promise<IListResponse<ITravel[]>>((resolve, reject) => {
      this.$services.travel.getAll(payload, i18n.locale)
        .then(res => {
          resolve({
            ...res.data,
            results: res.data.results?.map(travel => {
              return new Travel(travel);
            })
          })
        })
        .catch(reject);
    });
  },
  getTravelById(context: Context, payload: number): Promise<ITravel | undefined> {
    return new Promise<ITravel | undefined>((resolve, reject) => {
      this.$services.travel.getById(payload, i18n.locale)
        .then(res => {
          let item = res.data;
          resolve(item ? new Travel(item) : undefined)
        })
        .catch(reject);
    });
  },
  getTravelLimits(): Promise<ITravelLimits> {
    return new Promise<ITravelLimits>((resolve, reject) => {
      this.$services.travel.getLimits()
        .then(res => {
          resolve(res.data)
        })
        .catch(reject);
    });
  },

  // criteria
  fetchCriterion(context: Context, payload: string): Promise<ICriterion<string>[]> {
    let action = 'fetch' + camelCase(payload);
    return context.dispatch(action);
  },

  fetchAccommodation(): Promise<IAccommodation[]> {
    return new Promise<IAccommodation[]>((resolve, reject) => {
      this.$services.travel.getAllAccommodation(i18n.locale)
        .then(res => {
          resolve(res.data.results?.map(accommodation => new Accommodation(accommodation)))
        })
        .catch(reject);
    });
  },
  getAccommodationById(context: Context, payload: number): Promise<IAccommodation | undefined> {
    return new Promise<IAccommodation | undefined>((resolve, reject) => {
      this.$services.travel.getAccommodationById(payload, i18n.locale)
        .then(res => {
          let item = res.data;
          resolve(item ? new Accommodation(item) : undefined)
        })
        .catch(reject);
    });
  },

  fetchTravelType(): Promise<IType[]> {
    return new Promise<IType[]>((resolve, reject) => {
      this.$services.travel.getAllTravelType(i18n.locale)
        .then(res => {
          resolve(res.data.results?.map(type => new Type(type)))
        })
        .catch(reject);
    });
  },
  getTravelTypeById(context: Context, payload: number): Promise<IType | undefined> {
    return new Promise<IType | undefined>((resolve, reject) => {
      this.$services.travel.getTravelTypeById(payload, i18n.locale)
        .then(res => {
          let item = res.data;
          resolve(item ? new Type(item) : undefined)
        })
        .catch(reject);
    });
  },

  fetchTaste(): Promise<ITaste[]> {
    return new Promise<ITaste[]>((resolve, reject) => {
      this.$services.travel.getAllTaste(i18n.locale)
        .then(res => {
          resolve(res.data.results?.map(taste => new Taste(taste)))
        })
        .catch(reject);
    });
  },
  getTasteById(context: Context, payload: number): Promise<ITaste | undefined> {
    return new Promise<ITaste | undefined>((resolve, reject) => {
      this.$services.travel.getTasteById(payload, i18n.locale)
        .then(res => {
          let item = res.data;
          resolve(item ? new Taste(item) : undefined)
        })
        .catch(reject);
    });
  },

  fetchLocation(): Promise<ILocation[]> {
    return new Promise<ILocation[]>((resolve, reject) => {
      this.$services.travel.getAllLocation(i18n.locale)
        .then(res => {
          resolve(res.data.results?.map(loc => new Location(loc)))
        })
        .catch(reject);
    });
  },
  getLocationById(context: Context, payload: number): Promise<ILocation | undefined> {
    return new Promise<ILocation | undefined>((resolve, reject) => {
      this.$services.travel.getLocationById(payload, i18n.locale)
        .then(res => {
          let item = res.data;
          resolve(item ? new Location(item) : undefined)
        })
        .catch(reject);
    });
  },

  fetchSeason(): Promise<ISeason[]> {
    return new Promise<ISeason[]>((resolve, reject) => {
      this.$services.travel.getAllSeason(i18n.locale)
        .then(res => {
          resolve(res.data.results?.map(s => new Season(s)))
        })
        .catch(reject);
    })
  },
  getSeasonById(context: Context, payload: number): Promise<ISeason | undefined> {
    return new Promise<ISeason | undefined>((resolve, reject) => {
      this.$services.travel.getSeasonById(payload, i18n.locale)
        .then(res => {
          let item = res.data;
          resolve(item ? new Season(item) : undefined)
        })
        .catch(reject);
    });
  }

}

const infoActions: IInfoActions = {
  fetchPartners(): Promise<IPartner[]> {
    return new Promise<IPartner[]>((resolve, reject) => {
      this.$services.info.getAllPartners(i18n.locale)
        .then(res => {
          resolve(res.data.results?.map(partner => new Partner(partner)))
        })
        .catch(reject);
    })
  },
  getPartnerById(context: Context, payload: number): Promise<IPartner | undefined> {
    return new Promise<IPartner | undefined>((resolve, reject) => {
      this.$services.info.getPartnerById(payload, i18n.locale)
        .then(res => {
          let item = res.data;
          resolve(item ? new Partner(item) : undefined)
        })
        .catch(reject);
    });
  },

  fetchContactWays(): Promise<IContactWay[]> {
    return new Promise<IContactWay[]>((resolve, reject) => {
      this.$services.info.getAllContactWays(i18n.locale)
        .then(res => {
          resolve(res.data.results?.map(way => new ContactWay(way)))
        })
        .catch(reject);
    })
  },
  fetchNews(): Promise<INewsData[]> {
    return new Promise<INewsData[]>((resolve, reject) => {
      this.$services.info.getAllNews(i18n.locale)
        .then(res => {
          resolve(res.data.results)
        })
        .catch(reject);
    })
  },
  getNewsById(context: Context, payload: number): Promise<INews | undefined> {
    return new Promise<INews | undefined>((resolve, reject) => {
      this.$services.info.getNewsById(payload, i18n.locale)
        .then(res => {
          let item = res.data;
          resolve(item ? new News(item) : undefined)
        })
        .catch(reject);
    });
  },

  fetchBeautyPlaces(): Promise<IBeautyPlaceData[]> {
    return new Promise<IBeautyPlaceData[]>((resolve, reject) => {
      this.$services.info.getAllBeautyPlaces(i18n.locale)
        .then(res => {
          resolve(res.data.results)
        })
        .catch(reject);
    })
  },
  getBeautyPlaceById(context: Context, payload: number): Promise<IBeautyPlace | undefined> {
    return new Promise<IBeautyPlace | undefined>((resolve, reject) => {
      this.$services.info.getBeautyPlaceById(payload, i18n.locale)
        .then(res => {
          let item = res.data;
          resolve(item ? new BeautyPlace(item) : undefined)
        })
        .catch(reject);
    });
  },
  getContactWayById(context: Context, payload: number): Promise<IContactWay | undefined> {
    return new Promise<IContactWay | undefined>((resolve, reject) => {
      this.$services.info.getContactWayById(payload, i18n.locale)
        .then(res => {
          let item = res.data;
          resolve(item ? new ContactWay(item) : undefined)
        })
        .catch(reject);
    });
  },

  fetchFaqItems(): Promise<IFaqItem[]> {
    return new Promise<IFaqItem[]>((resolve, reject) => {
      this.$services.info.getAllFaqItems(i18n.locale)
        .then(res => {
          resolve(res.data.results?.map(faq => new FaqItem(faq)))
        })
        .catch(reject);
    })
  },
  getFaqItemById(context: Context, payload: number): Promise<IFaqItem | undefined> {
    return new Promise<IFaqItem | undefined>((resolve, reject) => {
      this.$services.info.getFaqItemById(payload, i18n.locale)
        .then(res => {
          let item = res.data;
          resolve(item ? new FaqItem(item) : undefined)
        })
        .catch(reject);
    });
  }
}

const customerActions: ICustomerActions = {
  addContactRequest(context: Context, payload: IContactRequestPostData): Promise<IContactRequest> {
    return new Promise<IContactRequest>((resolve, reject) => {
      this.$services.customer.addContactRequest(payload, i18n.locale)
        .then(res => {
          let data = res.data;
          if (data) {
            resolve(new ContactRequest(data))
          } else {
            reject()
          }
        })
        .catch(reject);
    })
  }
}

const modalActions: IModalActions = {
  // setModal(context: Context, payload: IModalData): void {
  setModal(context: Context, payload: IModalInitData): void {
    this.$storage.mutations.setModal(payload)
  },
  closeModal(): void {
    this.$storage.mutations.setModal(undefined)
  },
}

const requestActions: IRequestActions = {
  addServiceOrder(context: Context, payload: IServiceOrderData): Promise<IAddOrderResponseData> {
    return new Promise<IAddOrderResponseData>((resolve, reject) => {
      this.$services.request.addServiceOrder(payload, i18n.locale)
        .then(res => {
          resolve(res.data)
        })
        .catch(reject);
    });
  },
  addPublicPlanOrder(context: Context, payload: IPublicPlanOrderData): Promise<IAddOrderResponseData> {
    return new Promise<IAddOrderResponseData>((resolve, reject) => {
      this.$services.request.addPublicPlanOrder(payload, i18n.locale)
          .then(res => {
            resolve(res.data)
          })
          .catch(reject);
    });
  },
  addPlanOrder(context: Context, payload: IPlanOrderData): Promise<IAddOrderResponseData> {
    return new Promise<IAddOrderResponseData>((resolve, reject) => {
      this.$services.request.addPlanOrder(payload, i18n.locale)
        .then(res => {
          resolve(res.data);
        })
        .catch(reject);
    });
  },
  addSolutionOrder(context: Context, payload: ISolutionOrderData): Promise<IAddOrderResponseData> {
    return new Promise<IAddOrderResponseData>((resolve, reject) => {
      this.$services.request.addSolutionOrder(payload, i18n.locale)
        .then(res => {
          resolve(res.data);
        })
        .catch(reject);
    });
  },
  addPromoCodeOrder(context: Context, payload: IPromoCodeOrderData): Promise<IAddOrderResponseData> {
    return new Promise<IAddOrderResponseData>((resolve, reject) => {
      this.$services.request.addPromoCodeOrder(payload, i18n.locale)
        .then(res => {
          resolve(res.data);
        })
        .catch(reject);
    });
  },

  getOrderByToken(context: Context, payload: IRequestExtended): Promise<IOrder | undefined> {
    return new Promise<IOrder | undefined>((resolve, reject) => {
      this.$services.request.getOrderByToken(payload, i18n.locale)
        .then(res => {
          let item = res.data;
          if (item) {
            this.$storage.actions.setOrder(item);
            resolve(new Order(item));
          } else {
            resolve(undefined);
          }
        })
        .catch(reject);
    });
  },
  addConsultationInfo(context: Context, payload: IRequestExtended<ITravelInfoIdsExtendedData>): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.$services.request.addConsultationInfo(payload)
        .then(resolve)
        .catch(reject);
    })
  },
  getOrderHistories(context: Context, payload: IRequestExtended): Promise<IOrderHistory[]> {
    return new Promise<IOrderHistory[]>((resolve, reject) => {
      this.$services.request.getOrderHistories(payload)
        .then(res => {
          resolve(res.data.results?.map(history => new OrderHistory(history)))
        })
        .catch(reject);
    })
  },
  getRequestTravelHistories(context: Context, payload: IRequestExtended): Promise<IRequestTravelHistory[]> {
    return new Promise<IRequestTravelHistory[]>((resolve, reject) => {
      this.$services.request.getRequestTravelHistories(payload)
        .then(res => {
          resolve(res.data.results?.map(history => new RequestTravelHistory(history)))
        })
        .catch(reject);
    })
  },
  appendService(context: Context, payload: IRequestExtended<IAppendServiceData>): Promise<IRequestService> {
    return new Promise<IRequestService>((resolve, reject) => {
      this.$services.request.appendService(payload)
        .then(res => {
          resolve(new RequestService(res.data))
        })
        .catch(reject);
    });
  },
  cancelOrder(context: Context, payload: IRequestExtended): Promise<IOrderUpdateStatus> {
    return new Promise<IOrderUpdateStatus>((resolve, reject) => {
      this.$services.request.cancelOrder(payload)
        .then(res => {
          resolve(res.data);
        })
        .catch(reject);
    });
  },

  setOrder(context: Context, payload: IOrderData): void {
    this.$storage.mutations.setOrder(payload);
  }
}

const paymentActions: IPaymentActions = {
  checkout(context: Context, payload: ICheckout): Promise<ICheckoutResponse> {
    return new Promise<ICheckoutResponse>((resolve, reject) => {
      this.$services.payment.checkout(payload)
        .then(res => {
          resolve(res.data);
        })
        .catch(reject);
    });
  }
}

const promoCodeActions: IPromoCodeActions = {
  fetchPromoCodes(context: Context, payload?: IRequestExtended<ICertItemFilterData>): Promise<IPromoCode[]> {
    return new Promise<IPromoCode[]>((resolve, reject) => {
      this.$services.promo.getAllPromoCodes(payload, i18n.locale)
        .then(res => {
          resolve(res.data.results?.map(code => new PromoCode(code)))
        })
        .catch(reject);
    });
  },
  getRequestPromoCodeHistories(context: Context, payload: IRequestExtended): Promise<IRequestPromoCodeHistory[]> {
    return new Promise<IRequestPromoCodeHistory[]>((resolve, reject) => {
      this.$services.promo.getRequestPromoCodeHistories(payload)
        .then(res => {
          resolve(res.data.results?.map(history => new RequestPromoCodeHistory(history)))
        })
        .catch(reject);
    });
  }
}
// style
const styleActions: any = {
  setCheckboxLabelColor({commit}: any, payload: boolean): void {
    commit('setCheckboxLabelColor', payload);
  },
}

const groupTravelActions: any = {
  setGroupTravel({commit}: any, payload: ITravel): void {
    commit('setGroupTravel', payload);
  }
}

const emailModalConditionActions: any = {
  setEmailModalCondition({ commit }: any, payload: boolean): void {
    commit('setEmailModalCondition', payload);
  }
}

const travelFormatRequestActions: any = {
  setTravelFormatRequest({ commit }: any, payload: string): void {
    commit('setTravelFormatRequest', payload);
  }
}

export const actions: IActions = {

  ...currencyActions,
  ...serviceActions,
  ...travelActions,
  ...infoActions,
  ...customerActions,
  ...modalActions,
  ...requestActions,
  ...paymentActions,
  ...promoCodeActions,
  ...styleActions,
  ...groupTravelActions,
  ...emailModalConditionActions,
  ...travelFormatRequestActions,

  updatePlatformInfo(): void {
    this.$services.platform.getPlatformInfo(i18n.locale)
      .then(res => {
        this.$storage.mutations.setPlatformInfo(res.data.results[0])
      });
  },

  setLoading(context: Context, payload: boolean): void {
    this.$storage.mutations.setLoading(payload)
  },
  setTheming(context: Context, payload: boolean): void {
    this.$storage.mutations.setTheming(payload)
  },
  setTheme(context: Context, payload: Theme): void {
    cookie.set('TRA-theme', payload as string);
    this.$storage.mutations.setTheme(payload)
  },
  setTravel(context: Context, payload: ITravelData): void {
    this.$storage.mutations.setTravel(payload)
  },
  setFilters(context: Context, payload: ITravelFilterData): void {
    this.$storage.mutations.setFilters(payload)
  },
}
